import { usePageContext } from "@components/GlobalContextProvider";

// get error message from code and messages object
const DEFAULT_CODE = "DEFAULT";
export type getErrorMessageType = (code: string, fallback?: string) => string;
export const useErrorMessage = (): {
  getErrorMessage: getErrorMessageType;
  errorMessages: { [Code: string]: string };
} => {
  const { errorMessages } = usePageContext();

  return {
    getErrorMessage: (code: string, fallback?: string) => {
      // if no code provided, return default error message
      if (!code?.length) return fallback || "";
      // if code provided, return error message with fallback if not found
      return (
        errorMessages[code] || fallback || errorMessages[DEFAULT_CODE] || ""
      );
    },
    errorMessages,
  };
};
